import React from 'react';
import PropTypes from 'prop-types';
import { ModalLauncher } from '@metarouter-private/mr-mui';
import { isEmpty } from 'lodash';
import ExportAllButton from './ExportAllButton';
import BulkExportModal from './BulkExportModal';

export default function BulkExportLauncher({ cluster, earliestSeen, reports }) {
  return (
    <ModalLauncher
      Launcher={ExportAllButton}
      launcherProps={{ disabled: isEmpty(reports) }}
      Modal={BulkExportModal}
      modalProps={{ cluster, earliestSeen, reports }}
    />
  );
}

BulkExportLauncher.propTypes = {
  cluster: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  earliestSeen: PropTypes.string.isRequired,
  reports: PropTypes.array,
};
